import axios from "axios";
export default {
  state: {
    currentPoi: null,
    categories: [],
    visitedPois: JSON.parse(localStorage.getItem("visitedPois")) || [],
  },

  mutations: {
    setCurrentPoi(state, currentPoi) {
      state.currentPoi = currentPoi;
    },

    setCategories(state, categories) {
      state.categories = categories;
    },

    setVisitedPois(state, visitedPois) {
      state.visitedPois = [...visitedPois];
    },
  },

  actions: {
    async getCategories({ commit }) {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/categories`
        );
        const filteredCategories = res.data.filter(
          (category) => category.id != 23
        );
        commit("setCategories", filteredCategories);
      } catch (e) {
        throw e;
      }
    },

    setVisitedPois({ commit, state }, payload) {
      console.log("payload", payload.poi, payload.isChecked);
      //add to array
      let visitedPois = [...state.visitedPois];

      if (payload.isChecked) {
        visitedPois.push(payload.poi);
      } else {
        visitedPois = [...visitedPois.filter((el) => el.id != payload.poi.id)];
      }
      commit("setVisitedPois", visitedPois);
      localStorage.setItem("visitedPois", JSON.stringify(visitedPois));
    },
  },
};
